import { createDomain } from "effector"
import { persist } from "effector-storage/local"

import { View } from "@/domains/auctions/model"

const domain = createDomain("auctionsListView")

export const setView = domain.createEvent<View>("setView")

export const $view = domain
  .createStore<View>("gridCompact", { name: "$view" })
  .on(setView, (_, view) => view)

persist({ store: $view })
